(() => {
  if (window.diffusioneModalsInitialized) return;
  window.diffusioneModalsInitialized = true;
  const getDialog = (id) => document.getElementById(id);
  const sessionKey = 'diffusione_missing_book_session';
  const readSession = () => document.cookie.split('; ').find((item) => item.startsWith(`${sessionKey}=`))?.slice(sessionKey.length + 1);
  const writeSession = (value) => {
    document.cookie = `${sessionKey}=${value}; Path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
  };
  let openDialogs = 0;

  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.dataset.fallbackOpen = 'true';
    }
    openDialogs += 1;
    if (dialog.id === 'libro-mancante' && !window.Shopify?.designMode) writeSession('shown');
    document.documentElement.setAttribute('scroll-lock', '');
  };

  const closeDialog = (dialog) => {
    if (!dialog?.open) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      delete dialog.dataset.fallbackOpen;
      dialog.dispatchEvent(new Event('close'));
    }
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-diffusione-modal]');
    if (opener) {
      event.preventDefault();
      const dialog = getDialog(opener.dataset.openDiffusioneModal);
      openDialog(dialog);
      return;
    }

    const closer = event.target.closest('[data-close-diffusione-modal]');
    if (closer) closeDialog(closer.closest('dialog'));
  });

  document.querySelectorAll('.diffusione-modal').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => {
      openDialogs = Math.max(0, openDialogs - 1);
      if (openDialogs === 0) document.documentElement.removeAttribute('scroll-lock');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('.diffusione-modal[open]');
    if (dialog) closeDialog(dialog);
  });

  const hash = window.location.hash.slice(1);
  const dialog = getDialog(hash);
  if (dialog?.classList.contains('diffusione-modal')) openDialog(dialog);

  if (window.Shopify?.designMode || !getDialog('libro-mancante')) return;
  if (!readSession()) writeSession(String(Date.now()));
  if (!readSession() || readSession() === 'shown') return;

  const tryAutoOpen = () => {
    const session = readSession();
    if (!session || session === 'shown') return;
    if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || document.documentElement.hasAttribute('scroll-lock')) {
      window.setTimeout(scheduleAutoOpen, 1000);
      return;
    }
    openDialog(getDialog('libro-mancante'));
  };
  const scheduleAutoOpen = () => {
    if (navigator.locks?.request) {
      navigator.locks.request(sessionKey, tryAutoOpen).catch(() => {});
    } else {
      tryAutoOpen();
    }
  };
  const startedAt = Number(readSession());
  const configuredDelay = Number(document.querySelector('[data-diffusione-modals]')?.dataset.autoOpenDelay);
  const delayMs = (Number.isFinite(configuredDelay) && configuredDelay >= 1 ? configuredDelay : 10) * 1000;
  if (Number.isFinite(startedAt)) window.setTimeout(scheduleAutoOpen, Math.max(0, delayMs - (Date.now() - startedAt)));
})();
